export class DataRequest<TResponse> {
  constructor(
    public method: string,
    public url: string,
    public data: any,
    public managedType: string,
    public returnType: string,
    public sendData: boolean) {
  }
}